import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class QrcodeScanGuard implements CanActivate {
  public constructor(private readonly _router: Router) {}

  public canActivate(): boolean | UrlTree {
    const navigation = this._router.getCurrentNavigation();
    const previousUrl = navigation?.previousNavigation?.finalUrl?.toString();

    // Allow access if coming from search-order page
    if (previousUrl?.includes('/search-order')) {
      return true;
    }

    // Redirect to search-order if not coming from there
    return this._router.createUrlTree(['/search-order']);
  }
}
